import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
	changeCurrentPath,
	fetchDetailList,
	getPdfItems,
	clearPdfItems,
	fetchCsvDataDetail,
	updatePrintFlag,
	resetDetailListState
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';
import MainButtons from '../../common/components/main-buttons';
import Tables from '../../common/components/table/common-table';

import AlertDialog from '../../common/components/dialog/alert-dialog';

import PdfViewer from '../../common/components/viewer/pdf-viewer';


const columns = [
	{ name: 'InsatsuStatusName', title: '印刷' ,width:110},
	{ name: 'NinushiTorihikiName', title: '取引名称' ,width:100},
	{ name: 'NohinYoteiYMD', title: '納品日',width:135 },
	{ name: 'OtodokesakiName', title: '納品先名称',width:200 },
	{ name: 'OtodokesakiAddress', title: '納品先住所' ,width:400},
	{ name: 'NinushiName', title: '荷主名',width:200 },
	{ name: 'DenpyoNO', title: '伝票番号' ,width:150},
	{ name: 'CarNumber', title: '車番' ,width:100},
	{ name: 'RotationNO', title: '回転' ,width:100},
	{ name: 'HaisoNO', title: '配送順' ,width:100},
	{ name: 'Yobi1', title: '予備項目1' ,width:200},
	{ name: 'TorikomiDateTime', title: '取込時刻' ,width:150},
];

const numberColumns = [];

const styles = theme => ({
	datePicker : {
		marginTop : '-10px',
		width:'150px'
	},
	fromTo : {
		padding: '0 15px',
		fontSize: '1.5rem',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
	},
	expands : {
		boxShadow:'initial'
	}
});

const DLMaxCount = 5000;
const PrintMaxCount = 1000;

class DetailList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rows : [],
			selection:[],
			sorts:[{columnName:'DenpyoNO',direction:'asc'}],
			dialogOpen:false,
			updateSelections:[],
			headerSelections:[],
			headerDateType : "3",
			headerSelectedDateFrom : null,
			headerSelectedDateTo : null,
			selectionDetailCount:0,
			showDlErrorDialog:false,
			showPrintErrorDialog:false,
        }

    }
    /** override methods **/
	UNSAFE_componentWillMount(){
		const { dispatch, settings} = this.props;
		const {dateType, selectedDateFrom, selectedDateTo} = settings;

		const selections = settings.selections.map(selection=>{
			return selection["id"];
		});
		this.setState({
			headerSelections:selections,
			headerDateType : dateType,
			headerSelectedDateFrom : selectedDateFrom,
			headerSelectedDateTo : selectedDateTo
		});
		const SessionID = this.props.auth.SessionID;
		dispatch(fetchDetailList({
			selections,
			SessionID
		}));
	}
	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
	componentWillUnmount(){
		const { dispatch} = this.props;
		dispatch(resetDetailListState());

	}


    /** event handlers **/
	handleRowDoubleClick = row => {

	};
	handleSelectionChange = selection => {
		let selectionDetailCount = 0;
		selection.forEach((row)=>{
			selectionDetailCount+=isNaN(row.DetailCount) ? 0 : row.DetailCount;
		});
		this.setState({
			selection,
			selectionDetailCount
		});
	};

	handleSortsChange = sorts =>{
		this.setState({sorts});
	}


	handleClickDL = event => {

		if(this.state.selectionDetailCount>DLMaxCount){
			this.setState({
				showDlErrorDialog:true
			});
			return;
		}

		const {dispatch} = this.props;
		const DetailNOs = this.state.selection.map(selection=>{
			return selection["id"];
		});
		dispatch(fetchCsvDataDetail({
			DetailNOs : DetailNOs,
			process_divide : 1,
			SessionID : this.props.auth.SessionID
		}));

	};

	handleClickBack = event => {
		this.props.history.push('/main-list');
	};


	handleDoPrint = event => {

		if(this.state.selection.length>PrintMaxCount){
			this.setState({
				showPrintErrorDialog:true
			});
			return;
		}

		const selections = this.state.selection.map(selection=>{
			return selection["id"];
		});
		this.setState({
			updateSelections:selections,
			dialogOpen:true
		});
	};

	handleClickSlipNo = (row) =>{
		const {dispatch,auth} = this.props;
		const selections = [row["id"]];
		this.setState({
			updateSelections:selections
		});
		dispatch(getPdfItems({
			selections,
			SessionID:auth.SessionID
		}));

	};

	afterCloseFunc = () => {
		const { dispatch} = this.props;
		dispatch(clearPdfItems());
	};

	handlePrint = () =>{
		this.setState({
			dialogOpen:false
		});


		const { dispatch,auth} = this.props;
		const {
			updateSelections,
			headerSelections,
			headerDateType,
			headerSelectedDateFrom,
			headerSelectedDateTo,
		} = this.state;

		dispatch(getPdfItems({
			selections:updateSelections,
			SessionID:auth.SessionID
		}));


		dispatch(updatePrintFlag({
			SessionID:auth.SessionID,
			selections : updateSelections,
			headerSelections,
			headerDateType,
			headerSelectedDateFrom,
			headerSelectedDateTo,
		}));

	};

	handleCancelPrint = () =>{
		this.setState({
			dialogOpen:false
		});
	};

	handleCloseDlError = () =>{
		this.setState({
			showDlErrorDialog:false
		});
	};

	handleClosePrintError = () =>{
		this.setState({
			showPrintErrorDialog:false
		});
	};


	render() {
		const {
		    settings, auth
		} = this.props;
		const {
			selection,dialogOpen,
			selectionDetailCount,showDlErrorDialog,showPrintErrorDialog,
			sorts
		} = this.state;

		const rows = settings.data;
		const disabled = !(selection.length);

		const { JigyoushaIsMaker, JigyoushaIsNohinJigyousha, JigyoushaIs3PL} = auth.user;
		const isMaker = JigyoushaIsMaker && !JigyoushaIsNohinJigyousha && !JigyoushaIs3PL;

		let mainButtons = [];
		if(isMaker){
			mainButtons = [
				{type:'DL',func:this.handleClickDL,disabled:disabled},
				{type:'BACK',func:this.handleClickBack,text:"一覧",hasMargin:true}
			];
		}
		else{
			mainButtons = [
				{type:'DL',func:this.handleClickDL,disabled:disabled},
				{type:'PRINT',func:this.handleDoPrint,disabled:disabled},
				{type:'BACK',func:this.handleClickBack,text:"一覧",hasMargin:true}
			];
		}



		const clickableColumns = [
			{name:'DenpyoNO',func:this.handleClickSlipNo}
		];

		const printDialogOpen = (settings.pdfPath !== undefined);

		const limitText = <span>対象データが大きいため、期間や荷主などでデータを絞り込んで下さい<br/>
			<br/>
			現在の選択件数 : {selectionDetailCount}<br/>
			※同時DL可能上限 : {DLMaxCount}件(明細数)</span>;

		const limitText2 = <span>対象データが大きいため、期間や荷主などでデータを絞り込んで下さい<br/>
			<br/>
			現在の選択件数 : {selection.length}<br/>
			※同時印刷可能上限 : {PrintMaxCount}件(伝票数)</span>;

		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					<section className="title_area">
						<h2>伝票印刷<span>明細</span></h2>
					</section>
					<section className="with_button">
						<Tables
							dataSource={rows}
							columns={columns}
							numberColumns={numberColumns}
							clickableColumns={clickableColumns}
							doubleClickFunc={this.handleRowDoubleClick}
							getSelections={this.handleSelectionChange}
							getSortOrders={this.handleSortsChange}
							defaultSorts={sorts}
							selections={selection}
						/>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				{printDialogOpen &&
				<PdfViewer
					filePath={settings.pdfPath}
					afterCloseFunc={this.afterCloseFunc}
				/>
				}
				<AlertDialog
					open={dialogOpen}
					title={"確認"}
					text={<span>選択された伝票が印刷済となります</span>}
					okFunction={this.handlePrint}
					closeFunction={this.handleCancelPrint}
				/>
				<ErrorDialog
					open={showDlErrorDialog}
					title={'利用制限'}
					text={limitText}
					afterCloseFunc={this.handleCloseDlError}
				/>
				<ErrorDialog
					open={showPrintErrorDialog}
					title={'利用制限'}
					text={limitText2}
					afterCloseFunc={this.handleClosePrintError}
				/>
				<ErrorDialog
					open={this.props.settings.isProcessError}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.detailListSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(DetailList);



// WEBPACK FOOTER //
// ./src/routes/detail-list/index.js